Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconFolderData: "data:image/svg+xml,%3csvg width='20' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.999 0H1a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V3.999l-.007-.117A1 1 0 0019 3H9.556L7.828.44A1 1 0 006.999 0zm-.531 2l1.728 2.559.075.098a1 1 0 00.754.342H18V14H2V2h4.468z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconFolderWidth: 20,
  iconFolderHeight: 16
};